module.exports = __webpack_public_path__ + "static/media/ButtonClick.bcc68f31.mp3";